module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/5/4-78cbf2b80e2cfa54348e47ab6d3d992a.jpg";